$('.horizontal-product-list').slick({
    slidesToShow: 1.5, // Default: show 1.5 slides on desktop
    slidesToScroll: 1,
    dots: true,
    infinite: false,
    arrows: false,
    appendDots: $('.cstm_dot'),
    customPaging: function (slider, i) {
        return '<button class="slick-dot"></button>';
    },
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1.2,
                slidesToScroll: 1,
                dots: true
            }
        },
        {
            breakpoint: 600, // Mobile screens
            settings: {
                slidesToShow: 1, // Show 1 full slide
                slidesToScroll: 1,
                dots: true
            }
        }
    ]
});

